import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';

export const axiosUploadImages = (acceptedImages) => {
    let { url } = config.image.upload;

    let formData = new FormData();

    if (typeof window.SecurityToken != 'undefined') {
        formData.set('SecurityID', window.SecurityToken);
    }

    acceptedImages.forEach((file) => {
        formData.append('Upload', file);
    });

    return axios
        .post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};
